/* global axios */
import ApiClient from './ApiClient';

class ZohoCrmIntegrationAPI extends ApiClient {
  constructor() {
    super('integrations/zoho_crm', { accountScoped: true });
  }

  status() {
    return axios.get(`${this.url}/status`);
  }

  authorizeUrl() {
    return axios.get(`${this.url}/authorize_url`);
  }

  disconnect() {
    return axios.post(`${this.url}/disconnect`);
  }

  searchLeads(phone) {
    return axios.post(`${this.url}/search_leads`, { phone });
  }

  markGestionPlus(leadId) {
    return axios.post(`${this.url}/mark_gestion_plus`, { lead_id: leadId });
  }

  searchRecords(phone, email) {
    return axios.post(`${this.url}/search_records`, { phone, email });
  }

  createCrmNote({ module: moduleName, recordId, content, title }) {
    return axios.post(`${this.url}/create_note`, {
      module: moduleName,
      record_id: recordId,
      content,
      title,
    });
  }
}

export default new ZohoCrmIntegrationAPI();
